import { SERVICE_DESSK_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { IServiceDeskL1ListResponse, IServiceDeskL1ListResponseData } from "@/api_framework/api_modals/ServiceDesk";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});

export const useServiceDeskResonsL1API = () => {
  const [reasonsList, setReasonsList] = useState<IServiceDeskL1ListResponseData[]>([]);
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const configuration = useConfiguration();
  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .get(SERVICE_DESSK_APIS?.SERVICE_DESK_L1_LIST?.baseURL ?? "", {
          params: {},
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IServiceDeskL1ListResponse>) => {
          if (res.data?.status) {
            setReasonsList(res.data.data?.l1_list);
          } else {
            setReasonsList([]);
          }
        })
        .catch((e: AxiosError) => {
          setReasonsList([]);
          sendCurl(e.config["curlCommand"]);
          captureError(e)
        });
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
      setReasonsList([]);
    }
  }, [dispatch]);
  return { execute, reasonsList };
};
